/**
 * FeaturedVideo - featured video block with play trigger.
 * Custom element: <featured-video>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class FeaturedVideo extends ThemeComponent {}
setFunctionName(FeaturedVideo, "FeaturedVideo");
const propertyTypes = {};
FeaturedVideo.prototype.$name = "FeaturedVideo";
FeaturedVideo.prototype.$info = JSON.parse('{"name":"FeaturedVideo","meta":{"isLegacy":false,"selector":"featured-video"},"props":[],"refs":[]}');
FeaturedVideo.prototype.$info.component = FeaturedVideo;
for (const prop of FeaturedVideo.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("FeaturedVideo/FeaturedVideo.ts", {
  FeaturedVideo: FeaturedVideo
}, void 0);